const formSelector = '.js-filter_redesign';
const inputSelector = '.js-filter_checkbox_redesign';
const showAllInputSelector = '.js-filter_show_all_redesign';
const submitButtonSelector = '.js-filter_submit_redesign';
window.up.compiler(formSelector, (form) => {
    const showAllInput = form.querySelector(showAllInputSelector);
    const inputs = form.querySelectorAll(inputSelector);
    const submitButton = form.querySelector(submitButtonSelector);
    if (showAllInput && submitButton) {
        const inputType = showAllInput.getAttribute('type');
        window.up.on(showAllInput, 'change', undefined, (event) => {
            const showAll = event.target.checked;
            if (inputType === 'checkbox') {
                inputs.forEach(checkbox => {
                    checkbox.checked = showAll;
                });
            }
            submitButton.disabled = !showAll;
        });
        if (inputType === 'checkbox') {
            inputs.forEach(checkbox => {
                window.up.on(checkbox, 'change', undefined, () => {
                    const allChecked = Array.from(inputs).every(checkbox => checkbox.checked);
                    showAllInput.checked = allChecked;
                    const someChecked = Array.from(inputs).some(checkbox => checkbox.checked);
                    submitButton.disabled = !someChecked;
                });
            });
        }
    }
});
export {};
